export default "__VITE_ASSET__Bmvqv_bZ__"